import FormattedMessage from 'I18n/components/FormattedMessage';
import { MultiLevelDropdown } from 'foundations-components/transitional/components/Dropdown';
import { useCatalogOptions } from './hooks/useCatalogOptions';
import { jsx as _jsx } from "react/jsx-runtime";
export const ACCatalogMultiSelect = props => {
  const options = useCatalogOptions();
  return /*#__PURE__*/_jsx(MultiLevelDropdown, Object.assign({
    autoPlacement: false,
    buttonUse: "tertiary-light",
    buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academy-navigation-lib.ACPage.header.catalogDropdown.buttonText"
    }),
    "data-test-id": "catalog-dropdown-filter",
    minMenuWidth: 240,
    options: options,
    placement: "bottom right"
  }, props));
};